module.exports = i18n;